import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { convertToYoutubeEmbedUrl } from '../helpers/youtube';
import {
  Button,
  IconButton,
  Text,
  Modal,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  ModalContent,
  ModalHeader,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useGetStudyGroup } from '../modules/app/hooks/useGetStudyGroup';
import { useGetStudyGroupProgram } from '../modules/app/hooks/useGetStudyGroupProgram';
import { AuthContext } from '../context/AuthProvider';
import HelpIcon from './icons/Help';

const videos: Record<string, string> = {
  '/': 'R63uetrSoEI',
  '/licenses/': '1pKqeuSz-M0',
};

const specialVideos: Record<string, string> = {
  ras: 'L0fzkqsDcuw',
  rasUnit1: 'PpNkwPtsrdQ',
  ai: 'pAJhbmoFN-k',
};

const Help = () => {
  const user = useContext(AuthContext);
  const { t } = useTranslation();
  const [helpVideo, setHelpVideo] = useState<string | null>(null);
  const [studyGrupId, setStudyGrupId] = useState('');

  const location = useLocation();
  const [studyGroup] = useGetStudyGroup(studyGrupId);
  const [program] = useGetStudyGroupProgram(studyGroup);

  useEffect(() => {
    if (!user?.is_demo) {
      return;
    }
    const openedVideosRaw = localStorage.getItem('OPENED_VIDEOS');
    let openedVideos: any = {};
    if (openedVideosRaw) {
      try {
        openedVideos = JSON.parse(openedVideosRaw);
      } catch (e) {
        localStorage.setItem('OPENED_VIDEOS', JSON.stringify({}));
      }
    }
    const video = getPageVideo();
    if (video && openedVideos && openedVideos[video]) {
      return;
    } else if (video) {
      openedVideos[video] = true;
      localStorage.setItem('OPENED_VIDEOS', JSON.stringify(openedVideos));
    }
    selectHelpVideo();
  }, [user, location, program]);

  useEffect(() => {
    if (location.pathname.includes('/class/')) {
      const parts = location.pathname.split('/class/');
      if (parts[1]) {
        const subparts = parts[1].split('/');
        if (subparts[0]) {
          setStudyGrupId(subparts[0]);
        }
      }
    }
  }, [location]);

  const getPageVideo = () => {
    if (location.pathname.includes('/class')) {
      if (program) {
        if (
          program.name.includes('Robotics and Automated') &&
          location.pathname.includes('/unit') &&
          !location.pathname.includes('/units')
        ) {
          return specialVideos.rasUnit1;
        } else if (program.name.includes('Robotics and Automated')) {
          return specialVideos.ras;
        } else if (program.name.includes('AI')) {
          return specialVideos.ai;
        }
      }
      return null;
    }
    const video = videos[location.pathname];
    return video;
  };

  const selectHelpVideo = () => {
    const video = getPageVideo();
    if (video) {
      setHelpVideo(convertToYoutubeEmbedUrl('', video));
    }
  };

  return (
    <>
      <Modal isOpen={!!helpVideo} size="4xl" onClose={() => setHelpVideo(null)}>
        <ModalOverlay />
        <ModalContent
          mx={[4, 4, 8]}
          p={[2]}
          alignSelf="center"
        >
          <ModalHeader>
            <Text as="h4" textStyle="h4">
              Walkthrough video
            </Text>
          </ModalHeader>
          <ModalBody>
            <iframe
              style={{ width: '100%', aspectRatio: '1.78' }}
              src={helpVideo as string}
              title="YouTube video player"
              frameBorder="0"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </ModalBody>
          <ModalFooter>
            <Button
              variant="outline"
              colorScheme="blue"
              style={{ marginLeft: '8px' }}
              onClick={() => setHelpVideo(null)}
            >
              {t("general.close")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {user?.is_demo && (
        <IconButton
          aria-label="Help button"
          variant="solid"
          zIndex={1001}
          w="60px"
          h="60px"
          position="fixed"
          left="40px"
          bottom="40px"
          padding="10px"
          borderRadius="100px"
          boxShadow="3px 3px 5px 0px #0005"
          border="2px solid #000a"
          background="#fff8f4"
          icon={<HelpIcon h="35px" w="35px" color="#000d" />}
          onClick={() => {
            selectHelpVideo();
          }}
        ></IconButton>
      )}
      <Link
        className="pdf-link"
        style={{ color: '#767676' }}
        to="#"
        onClick={() => {
          selectHelpVideo();
        }}
      >
        {t("help.help")}
      </Link>
    </>
  );
};

export default Help;
